export enum AnimationState {
	VISIBLE = 'visible',
	EXITING = 'exiting',
	ENTERING = 'entering',
}
